import http from "../../http-common"

class SearchPageTabOptionsService {
    getPageTabOptions() {
        return http.get(`/search/tabs-options`)
    }
}


export default new SearchPageTabOptionsService();